import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: { 'Cache-Control': 'no-cache' }, // To avoid caching
});

export default axiosInstance;
